import UserGroupsContainer from './UserGroupsContainer';

export default UserGroupsContainer;